/**
 * Formats a number as a price with the specified locale
 * @param amount - The amount to format
 * @param locale - The locale to use for formatting (e.g., 'nb-NO' for Norwegian, 'sv-SE' for Swedish)
 * @returns Formatted price string without decimals
 */
export const formatPrice = (amount: number, locale: string = "nb-NO"): string => {
	return new Intl.NumberFormat(locale, {
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	}).format(amount);
};

/**
 * Selects the correct price value based on store type.
 * B2B stores display net (excl. VAT); B2C stores display gross (incl. VAT).
 * Falls back to gross when net is missing.
 * @param price - Object containing both net and gross values
 * @param isB2B - Whether the current store is a B2B store
 */
export const selectPrice = (price: { net: number; gross: number }, isB2B: boolean): number => {
	return isB2B ? (price.net ?? price.gross) : price.gross;
};